import React from "react";
import clsx from "clsx";
import { Button } from "react-bootstrap";
// import PropTypes from "prop-types";
import styles from "./styles/PromotionsTab.module.css";

const PromotionsTab = () => {
  return (
    <div className={clsx("border rounded p-5", styles.container)}>
      <img
        src="https://gambolthemes.net/html-items/cursus_main_demo/images/dashboard/promotion.svg"
        alt=""
      />
      <h5 className="mt-3">Baby promotion plan is activated!</h5>
      <p className="mt-3">
        By activating promotion plans you can improve course views and sales.
      </p>
      <Button className={styles.btnChange}>Change New Plan</Button>
    </div>
  );
};

/* required: display name */
PromotionsTab.displayName = "PromotionsTab";

/* required: props types */
PromotionsTab.propTypes = {};

/* required: default props */
PromotionsTab.defaultProps = {};

export { PromotionsTab };
